// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.muted {
  font-size: 12px;
  color: #667085;
}

.empty-note {
  margin: 8px 0 16px;
  color: #667085;
  font-size: 14px;
}

.qr-embedded-wrap {
  padding: 0 30px 30px 0;
}
@media (max-width: 767px) {
  .qr-embedded-wrap {
    padding: 0 16px 20px;
  }
}

.qr-forms {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(360px, 100%), 1fr));
  gap: 20px;
  margin-bottom: 28px;
  align-items: start;
}

.qr-form {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 16px rgba(16, 24, 40, 0.06);
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.qr-form::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 4px;
  background: linear-gradient(90deg, #5ea1d8, #8cc0ea);
}
.qr-form:hover {
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.06), 0 10px 28px rgba(16, 24, 40, 0.1);
  transform: translateY(-1px);
}

.qr-form--score::before {
  background: linear-gradient(90deg, #7c5cd6, #a98ef0);
}

.qr-form__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 14px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 14px 14px 0 0;
}
.qr-form__head:focus-visible {
  outline: 2px solid #5ea1d8;
  outline-offset: -2px;
}

.qr-form__chevron {
  flex: 0 0 auto;
  color: #667085;
  transition: transform 0.2s ease;
}

.qr-form--open .qr-form__chevron {
  transform: rotate(180deg);
}

.qr-form__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-top: 1px solid #f2f4f7;
  background: transparent;
  color: #1d67a3;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.qr-form__toggle mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.qr-form__toggle:hover {
  background: #f9fafb;
}

.qr-form__icon {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(94, 161, 216, 0.12);
  color: #1d67a3;
}
.qr-form__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}

.qr-form--score .qr-form__icon {
  background: rgba(124, 92, 214, 0.12);
  color: #5b3fb8;
}

.qr-form__titles {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.qr-form__label {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #101828;
  line-height: 1.3;
}

.qr-form__title {
  font-size: 13px;
  color: #667085;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qr-pill {
  flex: 0 0 auto;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.12);
  color: #1d67a3;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.qr-pill--score {
  background: rgba(124, 92, 214, 0.12);
  color: #5b3fb8;
}

.qr-form__stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
  margin: 0 20px 16px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  background: #f9fafb;
}

.qr-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 14px;
}
.qr-stat + .qr-stat {
  border-left: 1px solid #eaecf0;
}

.qr-stat__value {
  font-size: 20px;
  font-weight: 700;
  color: #101828;
  line-height: 1.2;
}
.qr-stat__value small {
  font-size: 13px;
  font-weight: 500;
  color: #667085;
}

.qr-stat__label {
  font-size: 12px;
  color: #667085;
}

.qr-q {
  padding: 16px 20px;
  border-top: 1px solid #f2f4f7;
}

.qr-q__head {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.qr-q__num {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef4fb;
  color: #1d67a3;
  font-size: 12px;
  font-weight: 700;
}

.qr-q__body {
  min-width: 0;
  flex: 1 1 auto;
}

.qr-q__text {
  font-size: 14px;
  font-weight: 600;
  color: #1d2939;
  line-height: 1.4;
  word-break: break-word;
}

.qr-q__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  font-size: 12px;
  color: #667085;
}

.qr-tag {
  padding: 1px 8px;
  border-radius: 6px;
  border: 1px solid #e4e7ec;
  background: #fff;
  color: #475467;
  font-weight: 500;
}

.qr-bar {
  display: block;
  margin: 0 0 10px 34px;
}
.qr-bar:last-child {
  margin-bottom: 0;
}

.qr-bar--clickable {
  width: calc(100% - 26px);
  padding: 6px 8px;
  margin-bottom: 4px;
  margin-left: 26px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.qr-bar--clickable:hover {
  background: #f9fafb;
}
.qr-bar--clickable:focus-visible {
  outline: 2px solid #5ea1d8;
  outline-offset: 1px;
}

.qr-bar--active {
  background: #eef4fb;
  border-color: #c5d8ea;
}
.qr-bar--active:hover {
  background: #eef4fb;
}

.qr-answers {
  margin: 12px 0 0 34px;
}

.qr-answers__toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px 4px 6px;
  border: 1px solid #e4e7ec;
  border-radius: 999px;
  background: #fff;
  color: #1d67a3;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.qr-answers__toggle mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.qr-answers__toggle:hover {
  background: #f5f9fd;
}

.qr-answers__count {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef4fb;
  color: #1d67a3;
  font-size: 11px;
}

.qr-answers__panel {
  margin-top: 10px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  overflow: hidden;
}

.qr-answers__filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #eef4fb;
  font-size: 12px;
  color: #344054;
}

.qr-answers__list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 360px;
  overflow-y: auto;
}

.qr-answer-row {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) minmax(0, 1.3fr);
  grid-template-areas: "avatar who what" "avatar time what";
  -moz-column-gap: 10px;
       column-gap: 10px;
  row-gap: 2px;
  align-items: center;
  padding: 10px 12px;
  font-size: 13px;
}
.qr-answer-row + .qr-answer-row {
  border-top: 1px solid #f2f4f7;
}

.qr-answer-row--empty .qr-answer-row__text {
  color: #98a2b3;
  font-style: italic;
}

.qr-avatar {
  grid-area: avatar;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #5ea1d8, #7c5cd6);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.qr-answer-row__who {
  grid-area: who;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.qr-answer-row__name {
  font-weight: 600;
  color: #1d2939;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qr-answer-row__email {
  font-size: 11px;
  color: #667085;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qr-answer-row__time {
  grid-area: time;
  font-size: 11px;
  color: #98a2b3;
}

.qr-answer-row__what {
  grid-area: what;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
}

.qr-answer-row__text {
  color: #344054;
  white-space: pre-wrap;
  word-break: break-word;
}

.qr-photo img {
  display: block;
  width: 64px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e4e7ec;
}

.qr-answers__none {
  padding: 12px;
  font-size: 13px;
  color: #667085;
}

.qr-link {
  padding: 0;
  border: none;
  background: none;
  color: #1d67a3;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.qr-link:hover {
  text-decoration: underline;
}

.qr-answers__more {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border-top: 1px solid #f2f4f7;
  font-size: 12px;
  text-align: center;
}

@media (max-width: 575px) {
  .qr-answer-row {
    grid-template-columns: 30px minmax(0, 1fr);
    grid-template-areas: "avatar who" "avatar what" "avatar time";
  }
}
.qr-bar__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 5px;
  font-size: 13px;
}

.qr-bar__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  color: #344054;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qr-bar__track {
  display: block;
  height: 8px;
  border-radius: 999px;
  background: #f2f4f7;
  overflow: hidden;
}
.qr-bar__track span {
  display: block;
  height: 100%;
  min-width: 2px;
  background: linear-gradient(90deg, #5ea1d8, #7db6e4);
  border-radius: 999px;
  transition: width 0.4s ease;
}

.qr-bar--correct .qr-bar__track span {
  background: linear-gradient(90deg, #16a34a, #4ade80);
}

.qr-bar__count {
  flex: 0 0 auto;
  font-weight: 600;
  color: #1d2939;
  white-space: nowrap;
}
.qr-bar__count small {
  margin-left: 4px;
  font-weight: 500;
  color: #667085;
}

.qr-num {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-left: 34px;
}

.qr-num__tile {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #eaecf0;
}
.qr-num__tile span {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #667085;
}
.qr-num__tile b {
  font-size: 15px;
  color: #101828;
}

.qr-num__warn {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #fff7ed;
  color: #b54708;
  font-size: 12px;
  font-weight: 500;
}
.qr-num__warn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.qr-note {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 34px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px dashed #d0d5dd;
  font-size: 13px;
  color: #475467;
}
.qr-note mat-icon {
  flex: 0 0 auto;
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #5ea1d8;
}

.qr-correct,
.qr-wrong {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.qr-correct {
  color: #16a34a;
}

.qr-wrong {
  color: #dc2626;
}

.qr-row {
  cursor: pointer;
}

.qr-toggle {
  width: 36px;
  color: #667085;
}

.qr-detail td {
  background: #f9fafb;
}

.qr-answer {
  padding: 6px 4px;
}
.qr-answer + .qr-answer {
  border-top: 1px solid #eaecf0;
}

.qr-answer__q {
  font-size: 13px;
  font-weight: 500;
  color: #344054;
}

.qr-answer__a {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 2px;
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-word;
}

:host-context(body.theme-dark) .qr-form {
  background: #1b1f27;
  border-color: #2f3542;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
}
:host-context(body.theme-dark) .qr-form__stats,
:host-context(body.theme-dark) .qr-num__tile,
:host-context(body.theme-dark) .qr-note {
  background: #151922;
  border-color: #2f3542;
}
:host-context(body.theme-dark) .qr-stat + .qr-stat,
:host-context(body.theme-dark) .qr-q {
  border-color: #2f3542;
}
:host-context(body.theme-dark) .qr-tag {
  background: transparent;
  border-color: #2f3542;
  color: #cbd5e1;
}
:host-context(body.theme-dark) .qr-q__num {
  background: rgba(94, 161, 216, 0.18);
  color: #8cc0ea;
}
:host-context(body.theme-dark) .qr-bar__track {
  background: #2f3542;
}
:host-context(body.theme-dark) .qr-num__warn {
  background: rgba(181, 71, 8, 0.15);
  color: #fdb022;
}
:host-context(body.theme-dark) .qr-form__toggle,
:host-context(body.theme-dark) .qr-answer-row + .qr-answer-row,
:host-context(body.theme-dark) .qr-answers__more {
  border-color: #2f3542;
}
:host-context(body.theme-dark) .qr-form__toggle:hover,
:host-context(body.theme-dark) .qr-bar--clickable:hover {
  background: #151922;
}
:host-context(body.theme-dark) .qr-bar--active,
:host-context(body.theme-dark) .qr-bar--active:hover,
:host-context(body.theme-dark) .qr-answers__filter {
  background: rgba(94, 161, 216, 0.14);
  border-color: rgba(94, 161, 216, 0.35);
}
:host-context(body.theme-dark) .qr-answers__toggle {
  background: transparent;
  border-color: #2f3542;
  color: #8cc0ea;
}
:host-context(body.theme-dark) .qr-answers__count {
  background: rgba(94, 161, 216, 0.18);
  color: #8cc0ea;
}
:host-context(body.theme-dark) .qr-answers__panel {
  border-color: #2f3542;
}
:host-context(body.theme-dark) .qr-answer-row__name {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .qr-answer-row__text,
:host-context(body.theme-dark) .qr-answers__filter {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .qr-form__toggle,
:host-context(body.theme-dark) .qr-link {
  color: #8cc0ea;
}
:host-context(body.theme-dark) .qr-detail td {
  background: #151922;
}
:host-context(body.theme-dark) .qr-form__label,
:host-context(body.theme-dark) .qr-q__text,
:host-context(body.theme-dark) .qr-stat__value,
:host-context(body.theme-dark) .qr-num__tile b,
:host-context(body.theme-dark) .qr-bar__count {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .qr-answer__q,
:host-context(body.theme-dark) .qr-bar__label,
:host-context(body.theme-dark) .qr-note {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .qr-form__title,
:host-context(body.theme-dark) .qr-q__meta,
:host-context(body.theme-dark) .qr-stat__label,
:host-context(body.theme-dark) .qr-stat__value small,
:host-context(body.theme-dark) .qr-bar__count small,
:host-context(body.theme-dark) .qr-num__tile span {
  color: #98a2b3;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/question-responses/question-responses.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,sBAAA;AACF;AACE;EAHF;IAII,oBAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,uEAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+EAAA;EACA,gBAAA;EACA,qDAAA;AAEF;AAAE;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,oDAAA;AAEJ;AACE;EACE,+EAAA;EACA,2BAAA;AACJ;;AAGA;EACE,oDAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;AAAF;AAEE;EACE,0BAAA;EACA,oBAAA;AAAJ;;AAIA;EACE,cAAA;EACA,cAAA;EACA,+BAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AADF;AAGE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AADJ;AAIE;EACE,mBAAA;AAFJ;;AAMA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;AAHF;AAKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAHJ;;AAOA;EACE,oCAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAJF;;AAOA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAJF;;AAOA;EACE,oCAAA;EACA,cAAA;AAJF;;AAOA;EACE,aAAA;EACA,0DAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAJF;AAME;EACE,8BAAA;AAJJ;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AALF;AAOE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AALJ;;AASA;EACE,eAAA;EACA,cAAA;AANF;;AASA;EACE,kBAAA;EACA,6BAAA;AANF;;AASA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AANF;;AASA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;EACA,cAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AANF;;AASA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AANF;;AASA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AANF;;AASA;EACE,cAAA;EACA,qBAAA;AANF;AAQE;EACE,gBAAA;AANJ;;AAUA;EACE,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;AAPF;AASE;EACE,mBAAA;AAPJ;AAUE;EACE,0BAAA;EACA,mBAAA;AARJ;;AAYA;EACE,mBAAA;EACA,qBAAA;AATF;AAWE;EACE,mBAAA;AATJ;;AAaA;EACE,qBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAVF;AAYE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;;AAeA;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAZF;;AAeA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAZF;;AAeA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,aAAA;EACA,2DAAA;EACA,yDACE;EAEF,qBAAA;OAAA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAdF;AAgBE;EACE,6BAAA;AAdJ;;AAkBA;EACE,cAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAfF;;AAkBA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AAfF;;AAkBA;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAfF;;AAkBA;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAfF;AAiBE;EACE,0BAAA;AAfJ;;AAmBA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE;IACE,0CAAA;IACA,6DACE;EAjBJ;AACF;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AApBF;;AAuBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AApBF;;AAuBA;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AApBF;AAsBE;EACE,cAAA;EACA,YAAA;EACA,cAAA;EACA,oDAAA;EACA,oBAAA;EACA,2BAAA;AApBJ;;AAwBA;EACE,oDAAA;AArBF;;AAwBA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AArBF;AAuBE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AArBJ;;AAyBA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;EACA,iBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAtBF;AAwBE;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,cAAA;AAvBJ;;AA2BA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAxBF;AA0BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxBJ;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;AAzBF;AA2BE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAzBJ;;AA6BA;;EAEE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA1BF;;AA6BA;EACE,cAAA;AA1BF;;AA6BA;EACE,cAAA;AA1BF;;AA6BA;EACE,eAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,cAAA;AA1BF;;AA6BA;EACE,mBAAA;AA1BF;;AA6BA;EACE,gBAAA;AA1BF;AA4BE;EACE,6BAAA;AA1BJ;;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;AA3BF;;AA+BE;EACE,mBAAA;EACA,qBAAA;EACA,0CAAA;AA5BJ;AA+BE;;;EAGE,mBAAA;EACA,qBAAA;AA7BJ;AAgCE;;EAEE,qBAAA;AA9BJ;AAiCE;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AA/BJ;AAkCE;EACE,oCAAA;EACA,cAAA;AAhCJ;AAmCE;EACE,mBAAA;AAjCJ;AAoCE;EACE,kCAAA;EACA,cAAA;AAlCJ;AAqCE;;;EAGE,qBAAA;AAnCJ;AAsCE;;EAEE,mBAAA;AApCJ;AAuCE;;;EAGE,oCAAA;EACA,sCAAA;AArCJ;AAwCE;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AAtCJ;AAyCE;EACE,oCAAA;EACA,cAAA;AAvCJ;AA0CE;EACE,qBAAA;AAxCJ;AA2CE;EACE,cAAA;AAzCJ;AA4CE;;EAEE,cAAA;AA1CJ;AA6CE;;EAEE,cAAA;AA3CJ;AA8CE;EACE,mBAAA;AA5CJ;AA+CE;;;;;EAKE,cAAA;AA7CJ;AAgDE;;;EAGE,cAAA;AA9CJ;AAiDE;;;;;;EAME,cAAA;AA/CJ","sourcesContent":[".muted {\n  font-size: 12px;\n  color: #667085;\n}\n\n.empty-note {\n  margin: 8px 0 16px;\n  color: #667085;\n  font-size: 14px;\n}\n\n.qr-embedded-wrap {\n  padding: 0 30px 30px 0;\n\n  @media (max-width: 767px) {\n    padding: 0 16px 20px;\n  }\n}\n\n.qr-forms {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(360px, 100%), 1fr));\n  gap: 20px;\n  margin-bottom: 28px;\n  align-items: start;\n}\n\n.qr-form {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e4e7ec;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 4px 16px rgba(16, 24, 40, 0.06);\n  overflow: hidden;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: 0 0 auto 0;\n    height: 4px;\n    background: linear-gradient(90deg, #5ea1d8, #8cc0ea);\n  }\n\n  &:hover {\n    box-shadow: 0 2px 4px rgba(16, 24, 40, 0.06), 0 10px 28px rgba(16, 24, 40, 0.1);\n    transform: translateY(-1px);\n  }\n}\n\n.qr-form--score::before {\n  background: linear-gradient(90deg, #7c5cd6, #a98ef0);\n}\n\n.qr-form__head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 20px 20px 14px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 14px 14px 0 0;\n\n  &:focus-visible {\n    outline: 2px solid #5ea1d8;\n    outline-offset: -2px;\n  }\n}\n\n.qr-form__chevron {\n  flex: 0 0 auto;\n  color: #667085;\n  transition: transform 0.2s ease;\n}\n\n.qr-form--open .qr-form__chevron {\n  transform: rotate(180deg);\n}\n\n.qr-form__toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 100%;\n  padding: 10px 16px;\n  border: none;\n  border-top: 1px solid #f2f4f7;\n  background: transparent;\n  color: #1d67a3;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    background: #f9fafb;\n  }\n}\n\n.qr-form__icon {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(94, 161, 216, 0.12);\n  color: #1d67a3;\n\n  mat-icon {\n    font-size: 22px;\n    width: 22px;\n    height: 22px;\n  }\n}\n\n.qr-form--score .qr-form__icon {\n  background: rgba(124, 92, 214, 0.12);\n  color: #5b3fb8;\n}\n\n.qr-form__titles {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.qr-form__label {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #101828;\n  line-height: 1.3;\n}\n\n.qr-form__title {\n  font-size: 13px;\n  color: #667085;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.qr-pill {\n  flex: 0 0 auto;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.12);\n  color: #1d67a3;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.qr-pill--score {\n  background: rgba(124, 92, 214, 0.12);\n  color: #5b3fb8;\n}\n\n.qr-form__stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));\n  margin: 0 20px 16px;\n  border: 1px solid #eaecf0;\n  border-radius: 10px;\n  background: #f9fafb;\n}\n\n.qr-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 10px 14px;\n\n  & + & {\n    border-left: 1px solid #eaecf0;\n  }\n}\n\n.qr-stat__value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #101828;\n  line-height: 1.2;\n\n  small {\n    font-size: 13px;\n    font-weight: 500;\n    color: #667085;\n  }\n}\n\n.qr-stat__label {\n  font-size: 12px;\n  color: #667085;\n}\n\n.qr-q {\n  padding: 16px 20px;\n  border-top: 1px solid #f2f4f7;\n}\n\n.qr-q__head {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.qr-q__num {\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #eef4fb;\n  color: #1d67a3;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.qr-q__body {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.qr-q__text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1d2939;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.qr-q__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  font-size: 12px;\n  color: #667085;\n}\n\n.qr-tag {\n  padding: 1px 8px;\n  border-radius: 6px;\n  border: 1px solid #e4e7ec;\n  background: #fff;\n  color: #475467;\n  font-weight: 500;\n}\n\n.qr-bar {\n  display: block;\n  margin: 0 0 10px 34px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.qr-bar--clickable {\n  width: calc(100% - 26px);\n  padding: 6px 8px;\n  margin-bottom: 4px;\n  margin-left: 26px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n\n  &:hover {\n    background: #f9fafb;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #5ea1d8;\n    outline-offset: 1px;\n  }\n}\n\n.qr-bar--active {\n  background: #eef4fb;\n  border-color: #c5d8ea;\n\n  &:hover {\n    background: #eef4fb;\n  }\n}\n\n.qr-answers {\n  margin: 12px 0 0 34px;\n}\n\n.qr-answers__toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px 4px 6px;\n  border: 1px solid #e4e7ec;\n  border-radius: 999px;\n  background: #fff;\n  color: #1d67a3;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    background: #f5f9fd;\n  }\n}\n\n.qr-answers__count {\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #eef4fb;\n  color: #1d67a3;\n  font-size: 11px;\n}\n\n.qr-answers__panel {\n  margin-top: 10px;\n  border: 1px solid #eaecf0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.qr-answers__filter {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: #eef4fb;\n  font-size: 12px;\n  color: #344054;\n}\n\n.qr-answers__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n.qr-answer-row {\n  display: grid;\n  grid-template-columns: 30px minmax(0, 1fr) minmax(0, 1.3fr);\n  grid-template-areas:\n    \"avatar who what\"\n    \"avatar time what\";\n  column-gap: 10px;\n  row-gap: 2px;\n  align-items: center;\n  padding: 10px 12px;\n  font-size: 13px;\n\n  & + & {\n    border-top: 1px solid #f2f4f7;\n  }\n}\n\n.qr-answer-row--empty .qr-answer-row__text {\n  color: #98a2b3;\n  font-style: italic;\n}\n\n.qr-avatar {\n  grid-area: avatar;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #5ea1d8, #7c5cd6);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.qr-answer-row__who {\n  grid-area: who;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.qr-answer-row__name {\n  font-weight: 600;\n  color: #1d2939;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.qr-answer-row__email {\n  font-size: 11px;\n  color: #667085;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.qr-answer-row__time {\n  grid-area: time;\n  font-size: 11px;\n  color: #98a2b3;\n}\n\n.qr-answer-row__what {\n  grid-area: what;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  min-width: 0;\n}\n\n.qr-answer-row__text {\n  color: #344054;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.qr-photo img {\n  display: block;\n  width: 64px;\n  height: 48px;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 1px solid #e4e7ec;\n}\n\n.qr-answers__none {\n  padding: 12px;\n  font-size: 13px;\n  color: #667085;\n}\n\n.qr-link {\n  padding: 0;\n  border: none;\n  background: none;\n  color: #1d67a3;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.qr-answers__more {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  border-top: 1px solid #f2f4f7;\n  font-size: 12px;\n  text-align: center;\n}\n\n@media (max-width: 575px) {\n  .qr-answer-row {\n    grid-template-columns: 30px minmax(0, 1fr);\n    grid-template-areas:\n      \"avatar who\"\n      \"avatar what\"\n      \"avatar time\";\n  }\n}\n\n.qr-bar__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.qr-bar__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  color: #344054;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.qr-bar__track {\n  display: block;\n  height: 8px;\n  border-radius: 999px;\n  background: #f2f4f7;\n  overflow: hidden;\n\n  span {\n    display: block;\n    height: 100%;\n    min-width: 2px;\n    background: linear-gradient(90deg, #5ea1d8, #7db6e4);\n    border-radius: 999px;\n    transition: width 0.4s ease;\n  }\n}\n\n.qr-bar--correct .qr-bar__track span {\n  background: linear-gradient(90deg, #16a34a, #4ade80);\n}\n\n.qr-bar__count {\n  flex: 0 0 auto;\n  font-weight: 600;\n  color: #1d2939;\n  white-space: nowrap;\n\n  small {\n    margin-left: 4px;\n    font-weight: 500;\n    color: #667085;\n  }\n}\n\n.qr-num {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-left: 34px;\n}\n\n.qr-num__tile {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #f9fafb;\n  border: 1px solid #eaecf0;\n\n  span {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #667085;\n  }\n\n  b {\n    font-size: 15px;\n    color: #101828;\n  }\n}\n\n.qr-num__warn {\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  background: #fff7ed;\n  color: #b54708;\n  font-size: 12px;\n  font-weight: 500;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.qr-note {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 34px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: #f9fafb;\n  border: 1px dashed #d0d5dd;\n  font-size: 13px;\n  color: #475467;\n\n  mat-icon {\n    flex: 0 0 auto;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: #5ea1d8;\n  }\n}\n\n.qr-correct,\n.qr-wrong {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 auto;\n}\n\n.qr-correct {\n  color: #16a34a;\n}\n\n.qr-wrong {\n  color: #dc2626;\n}\n\n.qr-row {\n  cursor: pointer;\n}\n\n.qr-toggle {\n  width: 36px;\n  color: #667085;\n}\n\n.qr-detail td {\n  background: #f9fafb;\n}\n\n.qr-answer {\n  padding: 6px 4px;\n\n  & + & {\n    border-top: 1px solid #eaecf0;\n  }\n}\n\n.qr-answer__q {\n  font-size: 13px;\n  font-weight: 500;\n  color: #344054;\n}\n\n.qr-answer__a {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-top: 2px;\n  font-size: 13px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n:host-context(body.theme-dark) {\n  .qr-form {\n    background: #1b1f27;\n    border-color: #2f3542;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);\n  }\n\n  .qr-form__stats,\n  .qr-num__tile,\n  .qr-note {\n    background: #151922;\n    border-color: #2f3542;\n  }\n\n  .qr-stat + .qr-stat,\n  .qr-q {\n    border-color: #2f3542;\n  }\n\n  .qr-tag {\n    background: transparent;\n    border-color: #2f3542;\n    color: #cbd5e1;\n  }\n\n  .qr-q__num {\n    background: rgba(94, 161, 216, 0.18);\n    color: #8cc0ea;\n  }\n\n  .qr-bar__track {\n    background: #2f3542;\n  }\n\n  .qr-num__warn {\n    background: rgba(181, 71, 8, 0.15);\n    color: #fdb022;\n  }\n\n  .qr-form__toggle,\n  .qr-answer-row + .qr-answer-row,\n  .qr-answers__more {\n    border-color: #2f3542;\n  }\n\n  .qr-form__toggle:hover,\n  .qr-bar--clickable:hover {\n    background: #151922;\n  }\n\n  .qr-bar--active,\n  .qr-bar--active:hover,\n  .qr-answers__filter {\n    background: rgba(94, 161, 216, 0.14);\n    border-color: rgba(94, 161, 216, 0.35);\n  }\n\n  .qr-answers__toggle {\n    background: transparent;\n    border-color: #2f3542;\n    color: #8cc0ea;\n  }\n\n  .qr-answers__count {\n    background: rgba(94, 161, 216, 0.18);\n    color: #8cc0ea;\n  }\n\n  .qr-answers__panel {\n    border-color: #2f3542;\n  }\n\n  .qr-answer-row__name {\n    color: #e2e8f0;\n  }\n\n  .qr-answer-row__text,\n  .qr-answers__filter {\n    color: #cbd5e1;\n  }\n\n  .qr-form__toggle,\n  .qr-link {\n    color: #8cc0ea;\n  }\n\n  .qr-detail td {\n    background: #151922;\n  }\n\n  .qr-form__label,\n  .qr-q__text,\n  .qr-stat__value,\n  .qr-num__tile b,\n  .qr-bar__count {\n    color: #e2e8f0;\n  }\n\n  .qr-answer__q,\n  .qr-bar__label,\n  .qr-note {\n    color: #cbd5e1;\n  }\n\n  .qr-form__title,\n  .qr-q__meta,\n  .qr-stat__label,\n  .qr-stat__value small,\n  .qr-bar__count small,\n  .qr-num__tile span {\n    color: #98a2b3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
